/* eslint-disable react-hooks/exhaustive-deps */
import { Outlet } from "react-router-dom";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

//styles
import "./assets/css/styles.css";
import "./assets/css/custom.css";
import "./assets/css/modal.css";
import "./index.css";

//Commons components
import Nav from "./components/Common/Nav";
import Top from "./components/Common/Top";

import Spinner from "./components/Common/Spinner";

import { useGlobal } from "./context/GlobalContextProvider.js";

library.add(fas);

function App() {
  const { userType, spinner } = useGlobal()

  return (
    <>
      <Top />
      <div className="d-flex" id="wrapper">
        {/* Navigation */}
        {["sponsor", 'artist'].includes(userType) && (
          <Nav />
        )}
        <div id="page-content-wrapper">
          {/* Content */}
          <div className="container-fluid">
            <Spinner spinner={spinner} />
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
